import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles<Theme>((theme) => ({
  title: {
    fontSize: "24px",
    fontWeight: 700,
    marginBottom: theme.spacing(2),
  },
  subTitle: {
    color: "#4B5D72",
    maxWidth: "553px",
  },
  imgStyles: {
    height: "201px",
    marginTop: "75px",
    marginBottom: "46px",
  },
}));

export default useStyles;
